/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CalculateLoanEligibleAmountParams,
  EligibilitySimulationRequest,
  EligibilitySimulationResponse,
  GetApplicableLoanEligibilityConfigParams,
  LoanEligibilityConfigDTO,
  SimulateWithConfigIdParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieve a specific loan eligibility configuration by its ID
 * @summary Get configuration by ID
 */
export const getLoanEligibilityConfigById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanEligibilityConfigByIdInfiniteQueryKey = (id?: number,) => {
    return [
    'infinite', `/api/loan-eligibility-config/${id}`
    ] as const;
    }

export const getGetLoanEligibilityConfigByIdQueryKey = (id?: number,) => {
    return [
    `/api/loan-eligibility-config/${id}`
    ] as const;
    }

    
export const getGetLoanEligibilityConfigByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>, TError = unknown>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityConfigByIdInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>> = ({ signal }) => getLoanEligibilityConfigById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityConfigByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>
export type GetLoanEligibilityConfigByIdInfiniteQueryError = unknown


export function useGetLoanEligibilityConfigByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>, TError = unknown>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by ID
 */

export function useGetLoanEligibilityConfigByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityConfigByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanEligibilityConfigByIdQueryOptions = <TData = Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityConfigByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>> = ({ signal }) => getLoanEligibilityConfigById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityConfigByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>>
export type GetLoanEligibilityConfigByIdQueryError = unknown


export function useGetLoanEligibilityConfigById<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigById<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigById<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by ID
 */

export function useGetLoanEligibilityConfigById<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityConfigByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an existing loan eligibility configuration
 * @summary Update configuration
 */
export const updateLoanEligibilityConfig = (
    id: number,
    loanEligibilityConfigDTO: LoanEligibilityConfigDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loanEligibilityConfigDTO
    },
      options);
    }
  


export const getUpdateLoanEligibilityConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanEligibilityConfig>>, TError,{id: number;data: LoanEligibilityConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLoanEligibilityConfig>>, TError,{id: number;data: LoanEligibilityConfigDTO}, TContext> => {

const mutationKey = ['updateLoanEligibilityConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLoanEligibilityConfig>>, {id: number;data: LoanEligibilityConfigDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLoanEligibilityConfig(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLoanEligibilityConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateLoanEligibilityConfig>>>
    export type UpdateLoanEligibilityConfigMutationBody = LoanEligibilityConfigDTO
    export type UpdateLoanEligibilityConfigMutationError = unknown

    /**
 * @summary Update configuration
 */
export const useUpdateLoanEligibilityConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanEligibilityConfig>>, TError,{id: number;data: LoanEligibilityConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLoanEligibilityConfig>>,
        TError,
        {id: number;data: LoanEligibilityConfigDTO},
        TContext
      > => {

      const mutationOptions = getUpdateLoanEligibilityConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a loan eligibility configuration
 * @summary Delete configuration
 */
export const deleteLoanEligibilityConfig = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/loan-eligibility-config/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLoanEligibilityConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteLoanEligibilityConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteLoanEligibilityConfig(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoanEligibilityConfigMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>>
    
    export type DeleteLoanEligibilityConfigMutationError = unknown

    /**
 * @summary Delete configuration
 */
export const useDeleteLoanEligibilityConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLoanEligibilityConfig>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteLoanEligibilityConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieve all active loan eligibility configurations ordered by priority
 * @summary Get all active configurations
 */
export const getAllActiveLoanEligibilityConfigs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO[]>(
      {url: `/api/loan-eligibility-config`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllActiveLoanEligibilityConfigsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/loan-eligibility-config`
    ] as const;
    }

export const getGetAllActiveLoanEligibilityConfigsQueryKey = () => {
    return [
    `/api/loan-eligibility-config`
    ] as const;
    }

    
export const getGetAllActiveLoanEligibilityConfigsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActiveLoanEligibilityConfigsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>> = ({ signal }) => getAllActiveLoanEligibilityConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActiveLoanEligibilityConfigsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>
export type GetAllActiveLoanEligibilityConfigsInfiniteQueryError = unknown


export function useGetAllActiveLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all active configurations
 */

export function useGetAllActiveLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActiveLoanEligibilityConfigsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllActiveLoanEligibilityConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActiveLoanEligibilityConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>> = ({ signal }) => getAllActiveLoanEligibilityConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActiveLoanEligibilityConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>>
export type GetAllActiveLoanEligibilityConfigsQueryError = unknown


export function useGetAllActiveLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all active configurations
 */

export function useGetAllActiveLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActiveLoanEligibilityConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new loan eligibility configuration
 * @summary Create new configuration
 */
export const createLoanEligibilityConfig = (
    loanEligibilityConfigDTO: LoanEligibilityConfigDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanEligibilityConfigDTO, signal
    },
      options);
    }
  


export const getCreateLoanEligibilityConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanEligibilityConfig>>, TError,{data: LoanEligibilityConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLoanEligibilityConfig>>, TError,{data: LoanEligibilityConfigDTO}, TContext> => {

const mutationKey = ['createLoanEligibilityConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLoanEligibilityConfig>>, {data: LoanEligibilityConfigDTO}> = (props) => {
          const {data} = props ?? {};

          return  createLoanEligibilityConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLoanEligibilityConfigMutationResult = NonNullable<Awaited<ReturnType<typeof createLoanEligibilityConfig>>>
    export type CreateLoanEligibilityConfigMutationBody = LoanEligibilityConfigDTO
    export type CreateLoanEligibilityConfigMutationError = unknown

    /**
 * @summary Create new configuration
 */
export const useCreateLoanEligibilityConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanEligibilityConfig>>, TError,{data: LoanEligibilityConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLoanEligibilityConfig>>,
        TError,
        {data: LoanEligibilityConfigDTO},
        TContext
      > => {

      const mutationOptions = getCreateLoanEligibilityConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test eligibility calculation with custom inputs and configuration. Uses the same calculation logic as the actual eligibility calculation, ensuring consistency between simulation and production.
 * @summary Simulate eligibility calculation
 */
export const simulateLoanEligibility = (
    eligibilitySimulationRequest: EligibilitySimulationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EligibilitySimulationResponse>(
      {url: `/api/loan-eligibility-config/simulate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eligibilitySimulationRequest, signal
    },
      options);
    }
  


export const getSimulateLoanEligibilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLoanEligibility>>, TError,{data: EligibilitySimulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof simulateLoanEligibility>>, TError,{data: EligibilitySimulationRequest}, TContext> => {

const mutationKey = ['simulateLoanEligibility'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateLoanEligibility>>, {data: EligibilitySimulationRequest}> = (props) => {
          const {data} = props ?? {};

          return  simulateLoanEligibility(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SimulateLoanEligibilityMutationResult = NonNullable<Awaited<ReturnType<typeof simulateLoanEligibility>>>
    export type SimulateLoanEligibilityMutationBody = EligibilitySimulationRequest
    export type SimulateLoanEligibilityMutationError = unknown

    /**
 * @summary Simulate eligibility calculation
 */
export const useSimulateLoanEligibility = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLoanEligibility>>, TError,{data: EligibilitySimulationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof simulateLoanEligibility>>,
        TError,
        {data: EligibilitySimulationRequest},
        TContext
      > => {

      const mutationOptions = getSimulateLoanEligibilityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Manually clear all loan eligibility configuration caches
 * @summary Evict all caches
 */
export const evictLoanEligibilityConfigCache = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/loan-eligibility-config/evict-cache`, method: 'POST', signal
    },
      options);
    }
  


export const getEvictLoanEligibilityConfigCacheMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>, TError,void, TContext> => {

const mutationKey = ['evictLoanEligibilityConfigCache'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>, void> = () => {
          

          return  evictLoanEligibilityConfigCache(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EvictLoanEligibilityConfigCacheMutationResult = NonNullable<Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>>
    
    export type EvictLoanEligibilityConfigCacheMutationError = unknown

    /**
 * @summary Evict all caches
 */
export const useEvictLoanEligibilityConfigCache = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evictLoanEligibilityConfigCache>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getEvictLoanEligibilityConfigCacheMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Activate or deactivate a loan eligibility configuration
 * @summary Toggle active status
 */
export const toggleLoanEligibilityConfigActive = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config/${id}/toggle-active`, method: 'PATCH'
    },
      options);
    }
  


export const getToggleLoanEligibilityConfigActiveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>, TError,{id: number}, TContext> => {

const mutationKey = ['toggleLoanEligibilityConfigActive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  toggleLoanEligibilityConfigActive(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleLoanEligibilityConfigActiveMutationResult = NonNullable<Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>>
    
    export type ToggleLoanEligibilityConfigActiveMutationError = unknown

    /**
 * @summary Toggle active status
 */
export const useToggleLoanEligibilityConfigActive = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleLoanEligibilityConfigActive>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getToggleLoanEligibilityConfigActiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test eligibility calculation using a saved configuration ID
 * @summary Simulate with saved configuration
 */
export const simulateWithConfigId = (
    configId: number,
    params: SimulateWithConfigIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EligibilitySimulationResponse>(
      {url: `/api/loan-eligibility-config/simulate/${configId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSimulateWithConfigIdInfiniteQueryKey = (configId?: number,
    params?: SimulateWithConfigIdParams,) => {
    return [
    'infinite', `/api/loan-eligibility-config/simulate/${configId}`, ...(params ? [params]: [])
    ] as const;
    }

export const getSimulateWithConfigIdQueryKey = (configId?: number,
    params?: SimulateWithConfigIdParams,) => {
    return [
    `/api/loan-eligibility-config/simulate/${configId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSimulateWithConfigIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof simulateWithConfigId>>>, TError = unknown>(configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSimulateWithConfigIdInfiniteQueryKey(configId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof simulateWithConfigId>>> = ({ signal }) => simulateWithConfigId(configId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SimulateWithConfigIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof simulateWithConfigId>>>
export type SimulateWithConfigIdInfiniteQueryError = unknown


export function useSimulateWithConfigIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof simulateWithConfigId>>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof simulateWithConfigId>>,
          TError,
          Awaited<ReturnType<typeof simulateWithConfigId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSimulateWithConfigIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof simulateWithConfigId>>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof simulateWithConfigId>>,
          TError,
          Awaited<ReturnType<typeof simulateWithConfigId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSimulateWithConfigIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof simulateWithConfigId>>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Simulate with saved configuration
 */

export function useSimulateWithConfigIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof simulateWithConfigId>>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSimulateWithConfigIdInfiniteQueryOptions(configId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSimulateWithConfigIdQueryOptions = <TData = Awaited<ReturnType<typeof simulateWithConfigId>>, TError = unknown>(configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSimulateWithConfigIdQueryKey(configId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof simulateWithConfigId>>> = ({ signal }) => simulateWithConfigId(configId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SimulateWithConfigIdQueryResult = NonNullable<Awaited<ReturnType<typeof simulateWithConfigId>>>
export type SimulateWithConfigIdQueryError = unknown


export function useSimulateWithConfigId<TData = Awaited<ReturnType<typeof simulateWithConfigId>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof simulateWithConfigId>>,
          TError,
          Awaited<ReturnType<typeof simulateWithConfigId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSimulateWithConfigId<TData = Awaited<ReturnType<typeof simulateWithConfigId>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof simulateWithConfigId>>,
          TError,
          Awaited<ReturnType<typeof simulateWithConfigId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSimulateWithConfigId<TData = Awaited<ReturnType<typeof simulateWithConfigId>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Simulate with saved configuration
 */

export function useSimulateWithConfigId<TData = Awaited<ReturnType<typeof simulateWithConfigId>>, TError = unknown>(
 configId: number,
    params: SimulateWithConfigIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof simulateWithConfigId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSimulateWithConfigIdQueryOptions(configId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Calculate loan eligible amount using applicable configuration
 * @summary Calculate eligible amount
 */
export const calculateLoanEligibleAmount = (
    params: CalculateLoanEligibleAmountParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/loan-eligibility-config/calculate`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getCalculateLoanEligibleAmountInfiniteQueryKey = (params?: CalculateLoanEligibleAmountParams,) => {
    return [
    'infinite', `/api/loan-eligibility-config/calculate`, ...(params ? [params]: [])
    ] as const;
    }

export const getCalculateLoanEligibleAmountQueryKey = (params?: CalculateLoanEligibleAmountParams,) => {
    return [
    `/api/loan-eligibility-config/calculate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCalculateLoanEligibleAmountInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>, TError = unknown>(params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateLoanEligibleAmountInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>> = ({ signal }) => calculateLoanEligibleAmount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateLoanEligibleAmountInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>
export type CalculateLoanEligibleAmountInfiniteQueryError = unknown


export function useCalculateLoanEligibleAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanEligibleAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanEligibleAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate eligible amount
 */

export function useCalculateLoanEligibleAmountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateLoanEligibleAmountInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCalculateLoanEligibleAmountQueryOptions = <TData = Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError = unknown>(params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalculateLoanEligibleAmountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>> = ({ signal }) => calculateLoanEligibleAmount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CalculateLoanEligibleAmountQueryResult = NonNullable<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>>
export type CalculateLoanEligibleAmountQueryError = unknown


export function useCalculateLoanEligibleAmount<TData = Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanEligibleAmount<TData = Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>,
          TError,
          Awaited<ReturnType<typeof calculateLoanEligibleAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCalculateLoanEligibleAmount<TData = Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Calculate eligible amount
 */

export function useCalculateLoanEligibleAmount<TData = Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError = unknown>(
 params: CalculateLoanEligibleAmountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calculateLoanEligibleAmount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCalculateLoanEligibleAmountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve an active loan eligibility configuration by its name
 * @summary Get configuration by name
 */
export const getLoanEligibilityConfigByName = (
    configName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config/by-name/${configName}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanEligibilityConfigByNameInfiniteQueryKey = (configName?: string,) => {
    return [
    'infinite', `/api/loan-eligibility-config/by-name/${configName}`
    ] as const;
    }

export const getGetLoanEligibilityConfigByNameQueryKey = (configName?: string,) => {
    return [
    `/api/loan-eligibility-config/by-name/${configName}`
    ] as const;
    }

    
export const getGetLoanEligibilityConfigByNameInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>, TError = unknown>(configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityConfigByNameInfiniteQueryKey(configName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>> = ({ signal }) => getLoanEligibilityConfigByName(configName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configName), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityConfigByNameInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>
export type GetLoanEligibilityConfigByNameInfiniteQueryError = unknown


export function useGetLoanEligibilityConfigByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>, TError = unknown>(
 configName: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by name
 */

export function useGetLoanEligibilityConfigByNameInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityConfigByNameInfiniteQueryOptions(configName,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanEligibilityConfigByNameQueryOptions = <TData = Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError = unknown>(configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanEligibilityConfigByNameQueryKey(configName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>> = ({ signal }) => getLoanEligibilityConfigByName(configName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanEligibilityConfigByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>>
export type GetLoanEligibilityConfigByNameQueryError = unknown


export function useGetLoanEligibilityConfigByName<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError = unknown>(
 configName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByName<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>,
          TError,
          Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanEligibilityConfigByName<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get configuration by name
 */

export function useGetLoanEligibilityConfigByName<TData = Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError = unknown>(
 configName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanEligibilityConfigByName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanEligibilityConfigByNameQueryOptions(configName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the most applicable configuration for a branch and product
 * @summary Get applicable configuration
 */
export const getApplicableLoanEligibilityConfig = (
    params: GetApplicableLoanEligibilityConfigParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO>(
      {url: `/api/loan-eligibility-config/applicable`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApplicableLoanEligibilityConfigInfiniteQueryKey = (params?: GetApplicableLoanEligibilityConfigParams,) => {
    return [
    'infinite', `/api/loan-eligibility-config/applicable`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetApplicableLoanEligibilityConfigQueryKey = (params?: GetApplicableLoanEligibilityConfigParams,) => {
    return [
    `/api/loan-eligibility-config/applicable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApplicableLoanEligibilityConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>, TError = unknown>(params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicableLoanEligibilityConfigInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>> = ({ signal }) => getApplicableLoanEligibilityConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApplicableLoanEligibilityConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>
export type GetApplicableLoanEligibilityConfigInfiniteQueryError = unknown


export function useGetApplicableLoanEligibilityConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>,
          TError,
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApplicableLoanEligibilityConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>,
          TError,
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApplicableLoanEligibilityConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get applicable configuration
 */

export function useGetApplicableLoanEligibilityConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApplicableLoanEligibilityConfigInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetApplicableLoanEligibilityConfigQueryOptions = <TData = Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError = unknown>(params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicableLoanEligibilityConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>> = ({ signal }) => getApplicableLoanEligibilityConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetApplicableLoanEligibilityConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>>
export type GetApplicableLoanEligibilityConfigQueryError = unknown


export function useGetApplicableLoanEligibilityConfig<TData = Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>,
          TError,
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApplicableLoanEligibilityConfig<TData = Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>,
          TError,
          Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetApplicableLoanEligibilityConfig<TData = Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get applicable configuration
 */

export function useGetApplicableLoanEligibilityConfig<TData = Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError = unknown>(
 params: GetApplicableLoanEligibilityConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicableLoanEligibilityConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetApplicableLoanEligibilityConfigQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve all loan eligibility configurations (active and inactive)
 * @summary Get all configurations
 */
export const getAllLoanEligibilityConfigs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanEligibilityConfigDTO[]>(
      {url: `/api/loan-eligibility-config/all`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllLoanEligibilityConfigsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/loan-eligibility-config/all`
    ] as const;
    }

export const getGetAllLoanEligibilityConfigsQueryKey = () => {
    return [
    `/api/loan-eligibility-config/all`
    ] as const;
    }

    
export const getGetAllLoanEligibilityConfigsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLoanEligibilityConfigsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>> = ({ signal }) => getAllLoanEligibilityConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLoanEligibilityConfigsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>
export type GetAllLoanEligibilityConfigsInfiniteQueryError = unknown


export function useGetAllLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations
 */

export function useGetAllLoanEligibilityConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLoanEligibilityConfigsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllLoanEligibilityConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllLoanEligibilityConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>> = ({ signal }) => getAllLoanEligibilityConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllLoanEligibilityConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>>
export type GetAllLoanEligibilityConfigsQueryError = unknown


export function useGetAllLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configurations
 */

export function useGetAllLoanEligibilityConfigs<TData = Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllLoanEligibilityConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllLoanEligibilityConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




